import React, { useEffect } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useMemberBenefits } from '@verzekeringapp-mono/shared/src/hooks/use_member_benefits'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getIsMemberBenefitLoading, getMemberBenefits as getMemberBenefitsFromSelector } from '@verzekeringapp-mono/shared/src/state/selectors/member_benefits'
import LoadingIndicator from '~/components/LoadingIndicator'
import dateUtils from '@verzekeringapp-mono/shared/src/utils/date_utils'
import { selectEffectiveTogglesForCurrent } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import NotCooperationMemberMessage from './components/not_cooperation_member_message'

const MemberBenefitScreen: React.FC = () => {
  const memberBenefits = useAppSelector(getMemberBenefitsFromSelector)
  const relationToggles = useAppSelector(selectEffectiveTogglesForCurrent)
  const isCooperationMember = relationToggles?.cooperationMembership ?? false
  const { getMemberBenefits } = useMemberBenefits(undefined, { enabled: isCooperationMember })
  const isLoading = useAppSelector(getIsMemberBenefitLoading)

  useEffect(() => {
    if (isCooperationMember) {
      getMemberBenefits()
    }
  }, [isCooperationMember])

  if (!relationToggles) {
    return null
  }

  const memberBenefitLayout = () => (
    <div className='grid md:grid-cols-2 gap-4 lg:grid-cols-3'>
      {memberBenefits.map(memberBenefit => (
        <a
          key={memberBenefit.id}
          className='flex flex-col justify-between rounded bg-surface-card p-4'
          href={`/ledenvoordelen/${memberBenefit.id}`}
        >
          <div>
            <div className='w-full aspect-[2/1] mb-4'>
              {memberBenefit.image
                ? (
                  <img
                    src={memberBenefit.image}
                    className='w-full h-full object-cover rounded'
                    alt=''
                  />
                )
                : (
                  <div className='h-full w-full rounded bg-surface-card-disabled' />
                )}
            </div>

            <p>{memberBenefit.title}</p>

            <p className='paragraph-light'>
              {
                dateUtils.getTillDate(memberBenefit.startDate, memberBenefit.endDate)
              }
            </p>
          </div>

          <div className='mt-2 '>
            <button className={'primary-btn w-full'}>
              <p>Bekijken</p>
            </button>
          </div>
        </a>
      ))}
    </div>
  )

  return (
    <ScreenWrapper>
      {!isCooperationMember && (
        <NotCooperationMemberMessage />
      )}

      {isCooperationMember && memberBenefits && memberBenefits.length === 0 && isLoading && (
        <div className='flex justify-center items-center'>
          <LoadingIndicator />
        </div>
      )}

      {isCooperationMember && memberBenefits && memberBenefits.length === 0 && !isLoading
        ? (
          <p className='html-content p-4'>
          Er zijn momenteel geen ledenvoordelen beschikbaar in de Mijn Omgeving.
          Klik op{' '}

            <a
              target='_blank'
              href='https://www.nh1816.nl/ledenvoordeel'
              rel='noreferrer'
            >
            nh1816.nl/ledenvoordeel
            </a>{' '}
          voor actuele ledenvoordelen.
          </p>
        )
        : (
          isCooperationMember && memberBenefitLayout()
        )}
    </ScreenWrapper>
  )
}

export default MemberBenefitScreen
